import { render } from "./InputReg.vue?vue&type=template&id=722269dc&scoped=true"
import script from "./InputReg.vue?vue&type=script&lang=js"
export * from "./InputReg.vue?vue&type=script&lang=js"

import "./InputReg.vue?vue&type=style&index=0&id=722269dc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722269dc"]])

export default __exports__